// extracted by mini-css-extract-plugin
module.exports = {"shadow":"StringPillModal_shadow__1lfM4","searchInput":"StringPillModal_searchInput__MSMsL","input":"StringPillModal_input__1fZKx","img":"StringPillModal_img__12Ggv"};